import { jsx, jsxs } from 'react/jsx-runtime';
import { Dialog, Button } from '@flex-design-system/fx';
import { Translation } from '@flex-mf/i18n';
import { EventPathBoundary, EventFeatureBoundary } from '@flexteam/logger';
import { forwardRefWithHook } from '@flexteam/shared-react';
import { useState, useImperativeHandle } from 'react';

const PreventFromLeavingDialog = forwardRefWithHook(
  function PreventFromLeavingDialog2({ onConfirm }, ref) {
    const [open, setOpen] = useState(false);
    useImperativeHandle(
      ref,
      () => ({
        open: () => setOpen(true),
        close: () => setOpen(false)
      }),
      []
    );
    return /* @__PURE__ */ jsx(Dialog, { open, onOpenChange: setOpen, children: /* @__PURE__ */ jsx(Dialog.Content, { children: /* @__PURE__ */ jsx(EventPathBoundary, { eventPathName: "userProfile", children: /* @__PURE__ */ jsxs(EventFeatureBoundary, { eventFeature: "userProfile/leavingConfirm", children: [
      /* @__PURE__ */ jsxs(Dialog.Body, { children: [
        /* @__PURE__ */ jsx(Dialog.UnbalancedTitle, { children: /* @__PURE__ */ jsx(Translation, { tKey: "@flex-services/user-profile.edit_modal.leave.confirm.title" }) }),
        /* @__PURE__ */ jsx(Dialog.UnbalancedDescription, { children: /* @__PURE__ */ jsx(Translation, { tKey: "@flex-services/user-profile.edit_modal.leave.confirm.description" }) })
      ] }),
      /* @__PURE__ */ jsxs(Dialog.Footer, { orientation: "vertical", children: [
        /* @__PURE__ */ jsx(Dialog.Action, { asChild: true, onClick: onConfirm, children: /* @__PURE__ */ jsx(Button, { danger: true, size: "large", fullWidth: true, children: /* @__PURE__ */ jsx(Translation, { tKey: "@flex-services/user-profile.global.\uB098\uAC00\uAE30" }) }) }),
        /* @__PURE__ */ jsx(Dialog.Cancel, { asChild: true, children: /* @__PURE__ */ jsx(Button, { variant: "ghost", color: "gray", size: "large", fullWidth: true, children: /* @__PURE__ */ jsx(Translation, { tKey: "@flex-services/user-profile.edit_modal.leave.confirm.cta.cancel" }) }) })
      ] })
    ] }) }) }) });
  }
);

export { PreventFromLeavingDialog as default };
//# sourceMappingURL=index.mjs.map
